/**
 * @title address.js: Feature level module
 * @description Module associated with address handling
 */
define(['preauthchargesmodal'], function(preauthchargesmodal) {
  var CAddress = {
    stateprov: '',
    addressTools: {
      applyAddressToOrder: "false",
      applyAddressToOrderItems: "false",
      addressType: '',
      cachedAddressId: '',
      errorContainer: ''
    },
    urlDelete: 'AjaxAddressAddCmd?mode=DELETE&addressId=',
    form: '',
    initialize: function(isReloaded) {
      COSTCO.util.getInitialAddressBatch();
    },
    // Hierarchy Setup for Modals -> Mode -> Type
    getHeaderLabels: function(type, mode) {
      var typeLabel, modeLabel;
      if (typeof(mode) !== 'undefined') {
        modeLabel = addressLabels[mode];
      }
      if (typeof(type) !== 'undefined') {
        if (type.trim() == 'S') {
          typeLabel = $.extend({}, addressLabels.shipping);
          if (typeof(modeLabel.shipping) !== 'undefined') {
            typeLabel = $.extend(typeLabel, modeLabel.shipping);
          }
        } else {
          typeLabel = $.extend({}, addressLabels.billing);
          if (typeof(modeLabel.billing) !== 'undefined') {
            typeLabel = $.extend(typeLabel, modeLabel.billing);
          }
        }
      }
      //added empty object as the first argument so that addressHeaderLabels stays in its original state
      return $.extend({}, addressHeaderLabels, modeLabel, typeLabel);
    },
    previousOptions: [],
    previousMode: [],
    previousType: [],
    pushModal: function(type, mode, options) {
      COSTCO.CAddress.previousOptions.push(options);
      COSTCO.CAddress.previousMode.push(mode);
      COSTCO.CAddress.previousType.push(type);
    },
    resetQueue: function() {
      COSTCO.CAddress.previousOptions = [];
      COSTCO.CAddress.previousMode = [];
      COSTCO.CAddress.previousType = [];
    },
    closeModal: function() {
      COSTCO.CAddress.resetQueue();
      COSTCO.dialog.closeAndUnbind();
    },
    baseModal: function(type, mode, options, poppin) {
      if (COSTCO.CAddress.previousOptions.length > 0 && typeof(options.secondary_event) === 'undefined') {
        var s_options = COSTCO.CAddress.previousOptions.pop();
        var s_mode = COSTCO.CAddress.previousMode.pop();
        var s_type = COSTCO.CAddress.previousType.pop();
        options.secondary_event = options.close = options.afterclose = function() {
          COSTCO.CAddress.baseModal(s_type, s_mode, s_options, true);
        }
      }
      var labels = CAddress.getHeaderLabels(type, mode);
      var addressOptions = {
        title: labels.modalTitle,
        primary: labels.primaryButton,
        secondary: messages.JS_DIALOG_CANCEL,
        secondary_event: function() {
          COSTCO.CAddress.closeModal();
        },
        close: function() {
          $('.order-ajax').removeClass('ajax-busy');
          COSTCO.CAddress.closeModal();
        },
        afterclose: function(e) {
          COSTCO.CAddress.closeModal();
        }
      }
      options = $.extend(addressOptions, options);
      if (typeof(poppin) === 'undefined') {
        COSTCO.CAddress.pushModal(type, mode, options);
      } else {
        COSTCO.CAddress.resetQueue();
        COSTCO.CAddress.pushModal(type, mode, options);
      }

      COSTCO.dialog.showAndHideModal(options);
    },
    urlAddUpdate: function(addressOptions) {
    	if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
    		document.getElementById("calendarServiceResponse").value = "";
    	}
    	 
    	let url = '';
    	if (typeof addressOptions  === 'undefined'){
    		url='/AjaxAddressAddCmd';
    	}else{
    		url = (addressOptions.url) ? addressOptions.url : '/AjaxAddressAddCmd';
    	}
    	let orderItemId = '';
    	let multiAddress = '';
        let addressIdsToUpdate = [];
      
      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
    	  if (!COSTCO.util.isBusinessDelivery()){
    		  orderItemId = addressOptions.orderItemId;
    	  }
        if (checkoutPage === 'multi-shipping') {
        multiAddress = 'true';
	        var cartCount = $.cookie('cartCountCookie');
	        for(i=0;i<cartCount;i++) {
	        	addressIdsToUpdate[i] = $('#addressId_'+(i+1)).val();
	        }
	        var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
        } else if (checkoutPage === 'shipping') {
          multiAddress = 'false';
        }
      }
      
      let queryObject = {
      		addressType: CAddress.addressTools.addressType,
      		applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
      		applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
      		orderItemId: orderItemId,
      		multiAddress: multiAddress,
      		modular: 'true',
      		requesttype: 'ajax',
      		addressIdsToUpdate: addressIdsToUpdateString
      };
      
      return COSTCO.util.makeUrl(url, queryObject);
    },
    
    urlAdd: function(addressOptions) {
    	if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
    		document.getElementById("calendarServiceResponse").value = "";
    	}
    	let url='';
    	if (typeof addressOptions  === 'undefined'){
    		url='/AjaxAddressAddCmd';
    	}else{
    		url = (addressOptions.url) ? addressOptions.url : '/AjaxAddressAddCmd';
    	}
      let orderItemId = '';
      let multiAddress = '';
      let addressIdsToUpdate = [];
      
      if (typeof checkoutPage !== 'undefined' && typeof addressOptions !== 'undefined') {
    	  if (!COSTCO.util.isBusinessDelivery()){
    		  orderItemId = addressOptions.orderItemId;
    	  }
        if (checkoutPage === 'multi-shipping') {
        multiAddress = 'true';
			var cartCount = $.cookie('cartCountCookie');
	        for(i=0;i<cartCount;i++) {
	        	addressIdsToUpdate[i] = $('#addressId_'+(i+1)).val();
	        }
	        var addressIdsToUpdateString = encodeURIComponent(JSON.stringify(addressIdsToUpdate));
	        CAddress.addressTools.applyAddressToOrderItems=false;
        } else if (checkoutPage === 'shipping') {
          multiAddress = 'false';
        }
      }
      let queryObject = {
      		addressType: CAddress.addressTools.addressType,
      		applyAddressToOrder: CAddress.addressTools.applyAddressToOrder,
      		applyAddressToOrderItems: CAddress.addressTools.applyAddressToOrderItems,
      		orderItemId: orderItemId,
      		multiAddress: multiAddress,
      		modular: 'true',
      		requesttype: 'ajax',
      		addressIdsToUpdate: addressIdsToUpdateString,
      		preventHtmlReload: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $((CAddress.addressTools.addressType === 'S' ? '#shipping' : '#billing') + ' #address-modal-inline').length > 0
      };
      
      return COSTCO.util.makeUrl(url, queryObject);
      
    },
    urlChoose: function(orderItemId) {
      return '/AjaxAddressAddCmd?mode=CHOOSE&addressType=' + CAddress.addressTools.addressType + '&applyAddressToOrder=' + CAddress.addressTools.applyAddressToOrder + '&applyAddressToOrderItems=' + CAddress.addressTools.applyAddressToOrderItems + '&orderItemId=' + orderItemId +'&modular=true&requesttype=ajax';
    },
    applyAddressToWhat: function(type) { // stateful change of addressTools url params
      if (type === 'B') {
        CAddress.addressTools.addressType = 'B';
        CAddress.addressTools.applyAddressToOrder = 'true';
        CAddress.addressTools.applyAddressToOrderItems = 'false';
      } 
      else if (type === 'S') {
        CAddress.addressTools.addressType = 'S'
        CAddress.addressTools.applyAddressToOrder = 'false';
        CAddress.addressTools.applyAddressToOrderItems = 'true';
      }
      else {
      	CAddress.addressTools.addressType = 'T';
        CAddress.addressTools.applyAddressToOrder = 'false';
        CAddress.addressTools.applyAddressToOrderItems = 'false';
      }
    },
    chooseAddress: function(oldAddyId, newAddyId, orderItemId) {
      let oldAddy = CAddress.getAddressElement(oldAddyId, '', true);
      let newAddy = CAddress.getAddressElement(newAddyId, '', true);
      var oldZipcode;
      var orderHasEddItems = $('#orderHasEddItems').val();
      if(newAddy.addressType === 'S' && undefined !== orderHasEddItems){
    	  if(orderHasEddItems === 'true'){
	    	  oldZipcode = $.cookie("invCheckPostalCode");
	    	  if(typeof(sessionStorage) !== "undefined" && null !== oldZipcode){
        		  sessionStorage.setItem('oldZipcode',oldZipcode);
        	  }
	          $.cookie("invCheckPostalCode", newAddy.zip.toUpperCase());
	      	  $.cookie("invCheckStateCode", newAddy.state);
	      	  $.cookie("invCheckCity", newAddy.city); 
    	  }
      }
      
    //update WAREHOUSEDELIVERY_WHS cookie when changing shipping address
      if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) 
    		  && typeof oldZipcode !== 'undefined' && typeof newAddy.zip !== 'undefined') {
		      if (oldZipcode.toUpperCase() != newAddy.zip.toUpperCase()) {
    	  CAddress.updateWarehouseCookie(newAddy.zip.toUpperCase());
      }
	}
      
    	if (!oldAddy) {
    		oldAddy = newAddy;
    	}
    	oldAddy['newAddressId'] = newAddy.id;
    	CAddress.applyAddressToWhat(oldAddy.addressType);
      let labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
    	let inputContainer = '#address_change_'+newAddyId;
      if(orderItemId) {
    	  inputContainer = '#address_change_'+newAddyId+'_'+ orderItemId;
      }

      let callChooseAddress = function() {

         COSTCO.Checkout.ajax_update_state({
          url: CAddress.urlChoose(orderItemId),
            method: "POST",
            dataType: 'json',
            data: {
            'authToken': COSTCO.Checkout.getAuthToken(),
            'oldZipcode':oldZipcode,
            formdata: encodeURIComponent(JSON.stringify(oldAddy)
            )
          },
          replaceKey: {
            original: 'address-block',
            replace: labels.replaceKey
          },
          done: function(data, textStatus, jqXHR, options) {
              if(checkoutPage === 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined'){
                COSTCO.CreditCard.initComplete = false;
              }
        	  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
          },
          ajax_update_post_done: function() {
            if (typeof checkoutPage != 'undefined') {
              apiAlreadyCalled = undefined;
              COSTCO.OrderItems.init();
              
              if (checkoutPage == 'review') {
              COSTCO.CreditCard.initComplete = false;
              COSTCO.CreditCard.init();
                 if (COSTCO.util.isBusinessDelivery()) {
                     COSTCO.Header.miniShopCartRefresh();
                 }
              } 
            }
            if(COSTCO.util.isBusinessDelivery() && newAddy.addressType == 'B') {
            	COSTCO.dialog.close();
            }
            $('body').trigger('costco.address.selected', newAddy);
          },
          ajax_handle_errors: function(response_obj) {

            let $errorContainer = $('#header-error-container');

            let application = response_obj.error.application || [];
            let exception = response_obj.error.exception || [];
            let error_html = '';
            if (exception.length > 0) {
              error_html += '<p>An unexpected error has occured</p>';
            }
            application.forEach(function(error_message) {
              error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
            });

            if (response_obj.error.redirect && error_html && error_html.indexOf(messages.ERR_INVALID_DUALCART_MSG) > -1) {
            	document.location.href = '/' + response_obj.error.redirect;
            	return;
            }
            
            let warning_data = response_obj.payload.data[0] || [];
            let warning_status = warning_data["warning"] || [];
            if(warning_status.length > 0) {
              let warning_message = warning_data["message"];
              error_html += '<p>'+warning_message+'</p>';
            }
            
            
            if (error_html == '' || error_html.length == 0) {
              $('body').trigger('costco.ajax.content.update.sucess', response_obj);

              if ($errorContainer.length > 0) {
                $errorContainer.children().remove();
                $errorContainer.removeClass('critical-notification');
              }

            } else {
              if ($errorContainer.length > 0) {
                $errorContainer.children().remove();
                $errorContainer.addClass('critical-notification');
                $errorContainer.append(error_html);
              }

              if (COSTCO.util.has_errors(response_obj)) {
                $('body').trigger('costco.ajax.content.update.error', response_obj);
              }
            }
          },
          always: function() {
           COSTCO.Checkout.ajax_update_default_always(inputContainer);
           COSTCO.preauthchargesmodal.init();
          },
          inputContainer: inputContainer,
          scrollToError: false
        });
      }

      if (newAddy.addressType === 'S' && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || (checkoutPage != 'shipping' && checkoutPage != 'review'))) {
        let submitZipCodeForValidation = function() {
          let submitParams = [orderItemId];
          let form = $('#formshipping');
          let callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
          if (checkoutPage == 'review') {
            form = $('#formreview');
          }
          form.find("input[name=zipCodeFormDeliveryZipCode]").val(newAddy.zip);
          COSTCO.zipCodeModal.submitZipCodeForValidation(form, callBack, null, submitParams, oldAddy, newAddy);
        }

        let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
        serviceToUpdateCookies(newAddy.zip)
        .then(() => {
        	if(COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' && 
  			  (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')){
        		submitZipCodeForValidation();
            	
        	}else{
        		callChooseAddress();
        	}
        },
        () => {
          //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
          if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' && 
              (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping')){
            submitZipCodeForValidation();
          }
        });
      } else {
        callChooseAddress();
      }
    },
    addressSetZipSuccess: function(data, params, form, newAddy) {
    	if (data.errorMessage){
    		$('#addressFormInlineButton').removeAttr('disabled');
    		COSTCO.CAddressForm.addressNotServicedModal(newAddy, undefined, function(){
				window.location.replace('http://'+$('#desktopHostName').val())
			})
    	}else{
    		//AJAX CALL to Merge Contract
    		$.ajax(
					{
						url: '/CheckoutCartView',
						type: 'POST',
						data: {skipCartRedirect:true
							  },
						dataType: 'html',
						success: function(data, textStatus, xhr){
							if (typeof checkoutPage != 'undefined') {
								COSTCO.OrderItems.order_prepare();
								
								// USBD only: force re-init of COSTCO.CreditCard when changing to delivery address ZIP on Place Order
								if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && 
										checkoutPage == 'review' && typeof COSTCO.CreditCard !== 'undefined') {
									COSTCO.CreditCard.initComplete = false;
								}
							}
							else{
								window.location.reload();
							}
						},
						error: function(xhr, textStatus, errorThrown){
							if (typeof checkoutPage != 'undefined') {
								COSTCO.OrderItems.order_prepare();
							}
							else{
								window.location.reload();
							}
							
						}
					}
			);	
    	}
    },
    /**
     * Choose new address.
     * @return {void}
     */
    callChooseAddressNew : function(orderItemId, oldAddy, newAddy, data) {
    	let labels = CAddress.getHeaderLabels(oldAddy['addressType'], 'choose');
    	let inputContainer = '#address_change_'+newAddy.id;
    	if(orderItemId) {
    		inputContainer = '#address_change_'+newAddy.id+'_'+ orderItemId;
    	}

    	var options = {
    			url: CAddress.urlChoose(orderItemId),
    			method: "POST",
    			dataType: 'json',
    			data: {
    				'authToken': COSTCO.Checkout.getAuthToken(),
        			formdata: encodeURIComponent(JSON.stringify(oldAddy)),
        			userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
    			},
    			replaceKey: {
    				original: 'address-block',
    				replace: labels.replaceKey
    			},
                done: function(data, textStatus, jqXHR, options) {
                  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined'){
                    COSTCO.CreditCard.initComplete = false;
                  }
                  // BD only: Update WC_BD_LOC cookie if ZIP is also changed on address change
                  if (COSTCO.util.isBusinessDelivery() && options.changeZip) {
                	  if ($('#isGeocodeService').val() != "true") {
                		  COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
                	  } else {
                		  COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
                	  }
                  }
                  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
                },
    			ajax_update_post_done: function(data) {
    				/* Default function body, extracted so it can be combined with promises. */
    				function postDone(data) {
    					COSTCO.CAddress.closeModal();
    					COSTCO.CAddress.bindEvents();
        				COSTCO.OrderItems.init();

        				if (checkoutPage === 'review') {
        					COSTCO.CreditCard.initComplete = false;
        					COSTCO.CreditCard.init();
                  if(COSTCO.util.isBusinessDelivery()) {
                    COSTCO.Header.miniShopCartRefresh();
                  }
        				} 
        				if(COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
        					$('#residential-address-notification').remove();
        				}
        			}
                  if (typeof checkoutPage != 'undefined') {
                    // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
                    if (COSTCO.util.isBusinessDelivery() && checkoutPage != 'cart' && $('input#whs-cookie-accertify').length 
                        && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
                      COSTCO.Checkout.ajaxRefreshAllCheckoutSections()
                      .then(() => { postDone(data); });
                    } else {
                      postDone(data);
                    }
                  }
                },
    			
        		always: function() {
        			COSTCO.Checkout.ajax_update_default_always(inputContainer);
        			COSTCO.preauthchargesmodal.init();
        		},
        		inputContainer: inputContainer,
        		scrollToError: false,
        		changeZip: oldAddy.zip != newAddy.zip
    	}
    	COSTCO.Checkout.ajax_update_state(options);
    } ,
    addressValidateSuccessOnChooseAddress: function(data, params, form, chosenAddress, oldAddy) {
      $('#addressFormInlineButton').removeAttr('disabled');
      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();
      var userDeliveryMethod = '';
      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
      //Set address type
      if (COSTCO.util.isNdEnabled()) {
        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
          userDeliveryMethod = 'Nationwide';
        }
        if (data.WarehouseChange && (data.IsInBDTruckZoneOnly)) {
          userDeliveryMethod = 'Local';
        }
        if (data.WarehouseChange && data.IsStorePickupOnly) {
          userDeliveryMethod = 'Store-Pick-Up';
        }
        data.userSelectionDeliveryMethod = userDeliveryMethod;
      }
      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod== 'Nationwide') {
        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
          window.location.replace('http://'+$('#desktopHostName').val())},"residentialNotServiced")
      } else if (data.BargeOrderZip == true) {
        if (oldAddy == null) {
          COSTCO.CAddress.callAddressAddNew(params[2],params[3],chosenAddress,params[4]);
        } else {
          COSTCO.CAddress.callChooseAddressNew(params[2],oldAddy,chosenAddress);
        }
        } else if (((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' ) || 
                    (data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local' )) && isUserCurrentOrderItemsAvailable) {
          COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod,oldAddy,chosenAddress);
        } else {
          if (data.StatusMessage==data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
            COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
            COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod,oldAddy,chosenAddress);
          } else {
            if (data.StatusMessage==data.ZipStatusMessageList[2] || data.StatusMessage==data.ZipStatusMessageList[0]  
                || data.StatusMessage==data.ZipStatusMessageList[4] || data.StatusMessage==data.ZipStatusMessageList[7]) {
              if (data.StatusMessage==data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
                COSTCO.CAddress.launchModalOnAddrChange(data, params, form, undefined, userDeliveryMethod,oldAddy,chosenAddress);
              } else {
                if (oldAddy == null) {
                  COSTCO.CAddress.callAddressAddNew(params[2],params[3],chosenAddress,params[4], data);
                } else {
                  COSTCO.CAddress.callChooseAddressNew(params[2],oldAddy,chosenAddress, data);
                }
              }
            } else {
              COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
                window.location.replace('http://'+$('#desktopHostName').val())
              })
            }
          }
        }
    },
    launchModalOnAddrChange : function(data, params, form, verifiedAddress, userDeliveryMethod,oldAddy,newAddy) {

	    var fromZipCodeToDisplay = data.bdZipCookieOriginal;
	    if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == ""){	
		  fromZipCodeToDisplay = data.CurrentDeliveryZip;
	    }
    	
    	var popupMsg = "";
		var isCheckoutFlow = false;
		if(typeof checkoutPage !== 'undefined'){
			if(checkoutPage=='review' || checkoutPage=='shipping' ){
				isCheckoutFlow = true;
			}
		}
		if (!COSTCO.util.isNdEnabled()) {
			// ND disabled flow
			popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
			popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
			popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
			
		} else if (data.RegisteredUser){
			// ND enabled flow
			if (data.InactiveZipMessage.length > 0) {
				popupMsg = data.InactiveZipMessage;
			} else if (data.NewWarehouseAlert.length > 0) {
				popupMsg = data.NewWarehouseAlert;
			}else if ((!isCheckoutFlow &&(data.ExternalCarrierChange || data.WarehouseChange)) || 
					(isCheckoutFlow &&(data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' ) || (data.WarehouseChange && userDeliveryMethod == 'Local' ))){
				var  errorMessage2 ;
				if(data.SetDeliveryZip == data.CurrentDeliveryZip){
					errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
				}else{
					errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
				}
				errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
				errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);					
				popupMsg=errorMessage2;			
			}else{
				var  errorMessage3;
				if(data.SetDeliveryZip == data.CurrentDeliveryZip){
					errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
				}else{
					errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
				}
				errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
				errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);					
				popupMsg=errorMessage3;
			}
		}else{
			var errorMessage1;
			if(data.SetDeliveryZip == data.CurrentDeliveryZip){
				errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
			}else{
				errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
			}
			errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
			errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);			
			popupMsg=errorMessage1;
		}
		
		if(data.StatusMessage==data.ZipStatusMessageList[5]) {
			COSTCO.zipCodeModal.dialogAlert(popupMsg,form);
		}else if(data.StatusMessage==data.ZipStatusMessageList[4] || 
				((data.StatusMessage==data.ZipStatusMessageList[7] && userDeliveryMethod &&
					!((data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' ) || 
						(data.WarehouseChange && userDeliveryMethod == 'Local' ))))) {
			COSTCO.CAddress.changeZipDialogOnAddrChange(data, params, popupMsg, form, verifiedAddress, userDeliveryMethod,oldAddy,newAddy);
		}else{
			if(COSTCO.util.isNdEnabled()){
				COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip,params,popupMsg,form,data,userDeliveryMethod,oldAddy,newAddy);
			}else{
				COSTCO.CAddress.dialogOnAddrChange(data.SetDeliveryZip,params,popupMsg,form,null,null,oldAddy,newAddy);
			}
			
		}
	},
	changeZipDialogOnAddrChange : function(data, params, popupMsg, form, verifiedAddress, userAddressType, oldAddy, newAddy){
		var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
		var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
		var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
		COSTCO.dialog.createExtDialogBox({
			title : titleMsg,
			body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode',{
			messageTxt: popupMsg,
			msgQuestion: messageQues}),
			primary: primaryButton,
			secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
			primary_event: function(){
				if(data!=null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip"){
					if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
						$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val('Local');
						COSTCO.zipCodeModal.submitZipCode(form);
					} else {
						COSTCO.zipCodeModal.viewAddressTypeModal(form, data, params);
					}
				} else if (COSTCO.util.isNdEnabled() && data && (data.StatusMessage==data.ZipStatusMessageList[4]
					|| data.StatusMessage==data.ZipStatusMessageList[7]) && data.ShowDeliveryMethodPopup) {
					COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, params, oldAddy, newAddy);
				} else {
					if(oldAddy == null){//add address flow
						COSTCO.CAddress.callAddressAddNew(params[2],params[3],newAddy,params[4]);
					}else{
						COSTCO.CAddress.callChooseAddressNew(params[2],oldAddy,newAddy);
					}
				}
			},
		});			
		$('.close').removeClass("hidden");
	},
	dialogOnAddrChange : function(currentZip, optParams, popupMsg, form, data, userDeliveryMethod, oldAddy, newAddy){
		var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
		var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
		var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
		COSTCO.dialog.createExtDialogBox({ 
			title : titleMsg,
			body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode',{
			messageTxt: popupMsg,
			msgQuestion: messageQues}),
			primary: primaryButton,
			secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
			primary_event: function(){
				if (COSTCO.util.isNdEnabled() && data && data.StatusMessage==data.ZipStatusMessageList[7] 
					&& data.ShowDeliveryMethodPopup) {
					COSTCO.CAddressVerification.viewDeliveryMethodModal(form, data, optParams, oldAddy, newAddy);
				} else {
					if(oldAddy == null){//add address flow
						COSTCO.CAddress.callAddressAddNew(optParams[2], optParams[3], newAddy, optParams[4], data);
					}else{
						COSTCO.CAddress.callChooseAddressNew(optParams[2], oldAddy, newAddy, data);
					}
				}
				
			}
		});			
	},
	/**
	 * Add new address.
	 * @return {void}
	 */
	callAddressAddNew : function(addressType,addressOptions,verifiedAddress,preventajaxhtml, data) {
		
        CAddress.applyAddressToWhat(addressType)
        if (checkoutPage == 'review' || checkoutPage == 'shipping') {
								isCheckoutFlow = true;
							}
        if(COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !isCheckoutFlow){ 
          CAddress.addressTools.applyAddressToOrderItems = 'false';
        }
        var labels = CAddress.getHeaderLabels(addressType, 'add');
        var options = {
          url: (verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions)),
          method: "POST",
          dataType: 'json',
          data: {
            'authToken': COSTCO.Checkout.getAuthToken(),
            formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
            userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
          },
          replaceKey: {
            original: 'address-block',
            replace: labels.replaceKey
          },
          done: function (data, textStatus, jqXHR, options) {
            if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && COSTCO.CreditCard !== undefined) {
              COSTCO.CreditCard.initComplete = false;
            }
            if(!data.errorMessage) {
              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
            } else {
              var parentNode = document.getElementById("costcoModalText");
              if (parentNode !== null){
                var newDiv = document.createElement("div");
                newDiv.innerHTML = data.errorMessage;
                newDiv.className = 'error'
                parentNode.prepend(newDiv);
              }
            } 
          },
          ajax_update_post_done: function(data) {
            /* Default function body, extracted so it can be combined with promises. */
            function postDone(data) {
            var application = data.error.application;
            if (application.length === 0) {
              COSTCO.util.resetAddressLoadState();
              COSTCO.CAddress.closeModal();
              $('body').trigger("costco.address.added", data.payload.data[1]);
            } else {
              $('body').trigger("costco.address.error", application);
            }
            CAddress.bindEvents();
           if(addressOptions.addressBookReinit) { 
              COSTCO.CAddressBook.init();
            }
            if (checkoutPage) {
              COSTCO.OrderItems.init();

              if (checkoutPage === 'review') {
              COSTCO.CreditCard.initComplete = false;
              COSTCO.CreditCard.init();
              if(COSTCO.util.isBusinessDelivery()) {
                COSTCO.Header.miniShopCartRefresh();
                COSTCO.preauthchargesmodal.init();
              }
              } 
              if(COSTCO.util.isBusinessDelivery() && COSTCO.util.isUSBDStore() && $('#residential-address-notification').length) {
                $('#residential-address-notification').remove();
              }
            }
          }
            // STRY0183851: BD only - in case of mismatch with Accertify.jspf cookie data, ajax-refresh Payment section
            if (typeof checkoutPage != 'undefined' && checkoutPage != 'cart' && COSTCO.util.isBusinessDelivery() && $('input#whs-cookie-accertify').length 
                && COSTCO.util.getBDZipCookie().warehouseNumber != $('input#whs-cookie-accertify').val()) {
              COSTCO.Checkout.ajaxRefreshAllCheckoutSections()
              .then (() => {postDone(data); });
            } else {
              postDone(data);
            }
          }
        }
        if (preventajaxhtml) {
          options.ajax_replace_content = function() {};
        }
        COSTCO.Checkout.ajax_update_state(options);
      },
    addressValidateSuccess: function(data, params, form, verifiedAddress) {
      $('#addressFormInlineButton').removeAttr('disabled');
      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();	
      var userDeliveryMethod = '';
      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
      if (COSTCO.util.isNdEnabled()) {
        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
        if (!data.ShowDeliveryMethodPopup && !data.ShowAddressTypePopup) {
          userDeliveryMethod = 'Nationwide';
        }
        if (!data.ShowDeliveryMethodPopup && data.IsInBDTruckZoneOnly) {
          userDeliveryMethod = 'Local';
        }
        if (!data.ShowDeliveryMethodPopup && data.IsStorePickupOnly) {
          userDeliveryMethod = 'Store-Pick-Up';
        }
      }
      if(data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
        COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function() {
          window.location.replace('http://'+$('#desktopHostName').val())}, "residentialNotServiced");
      } else if (data.BargeOrderZip == true) {
        COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
        $('body').bind('costco.address.added', function(event, address) {
          $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
          $('#NewAddressSingleShippingForm').submit();
        });
      } else {
        if (data.StatusMessage==data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
          COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
      } else {
        if (data.StatusMessage == data.ZipStatusMessageList[2] 
            || data.StatusMessage == data.ZipStatusMessageList[0] 
            || data.StatusMessage == data.ZipStatusMessageList[4] 
            || data.StatusMessage == data.ZipStatusMessageList[7]) {
          if (data.StatusMessage == data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data)) {
            COSTCO.zipCodeModal.launchModal(data, params, form, verifiedAddress);
          } else {
            if (COSTCO.util.isNdEnabled() && (data.StatusMessage == data.ZipStatusMessageList[4] 
                || data.StatusMessage == data.ZipStatusMessageList[7])
                && userDeliveryMethod == 'Local') {
              COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
            } else {
              data.userSelectionDeliveryMethod = userDeliveryMethod;
              COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
              $('body').bind('costco.address.added', function(event, address) {
                $('#NewAddressSingleShippingForm input[name="addressId"]').val(address.addressId);
                $('#NewAddressSingleShippingForm').submit();
              });
            }
          }
        } else {
          COSTCO.CAddressForm.addressNotServicedModal(verifiedAddress, undefined, function() {
            window.location.replace('http://'+$('#desktopHostName').val())})
          }
        }
      }
    },
    submitAddress: function(data, params, form, verifiedAddress) {
      if (data != null && data.BargeOrderZip == false) {
        COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
        COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
        $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
      }
      var addressType = '';
      if (verifiedAddress.addressType == null) {
        addressType = verifiedAddress.addressType2.trim();
      } else {
        addressType = verifiedAddress.addressType.trim();
      }
      CAddress.applyAddressToWhat(addressType);
      var labels = CAddress.getHeaderLabels(addressType, 'add');
      var options = {
        url: (verifiedAddress.id != "" ? CAddress.urlAddUpdate() : CAddress.urlAdd()),
        method: "POST",
        dataType: 'json',
        data: {
          'authToken': COSTCO.Checkout.getAuthToken(),
          formdata: encodeURIComponent(JSON.stringify(verifiedAddress)),
          userSelectionDeliveryMethod: data && data.userSelectionDeliveryMethod ? data.userSelectionDeliveryMethod : ''
        },
        replaceKey: {
          original: 'address-block',
          replace: labels.replaceKey
        },
        done: function (data, textStatus, jqXHR, options) {
          if (!data.errorMessage) {
            COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
          } else {
            var parentNode = document.getElementById("costcoModalText");
            if (parentNode != null) {
              var newDiv = document.createElement("div");
              newDiv.innerHTML = data.errorMessage;
              newDiv.className = 'error';
              parentNode.prepend(newDiv);
            }
          }
        },
        ajax_update_post_done: function(data) {
          var application = data.error.application;
          if (application.length == 0) {
            COSTCO.util.resetAddressLoadState();
            COSTCO.CAddress.closeModal();
            $('body').trigger("costco.address.added", data.payload.data[1]);
          } else {
            $('body').trigger("costco.address.error", application);
          }
          CAddress.bindEvents();
          if (typeof checkoutPage != 'undefined' && checkoutPage) {
            COSTCO.OrderItems.init();
            if (checkoutPage == 'review' && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
              COSTCO.CAddress.initializeCreditCardModule();
            } else if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#shipping #address-modal-inline').length === 0) {
              COSTCO.CAddress.initializeCreditCardModule();
            }
          }
        }
      }
      COSTCO.Checkout.ajax_update_state(options);
    },
    initializeCreditCardModule : function() {
      COSTCO.CreditCard.initComplete = false;
      COSTCO.CreditCard.init();
    },
    addressValidateSuccessOnPlaceOrder : function(data, params, form, chosenAddress){
      $('#addressFormInlineButton').removeAttr('disabled');
      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();	
      var userDeliveryMethod = '';
      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
      //Set address type
      if (COSTCO.util.isNdEnabled()) {
        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
          userDeliveryMethod = 'Nationwide';
        }
        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
          userDeliveryMethod = 'Local';
        }
        if (data.WarehouseChange && data.IsStorePickupOnly) {
          userDeliveryMethod = 'Store-Pick-Up';
        }
        data.userSelectionDeliveryMethod = userDeliveryMethod;
      }
      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
          window.location.replace('http://'+$('#desktopHostName').val())},"residentialNotServiced")
      } else if (data.BargeOrderZip == true) {
        COSTCO.OrderSummary.placeOrder();
      }else if (((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' ) || 
                 (data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local' )) && isUserCurrentOrderItemsAvailable) {
         COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
      } else {
        if (data.StatusMessage==data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
        } else {
          if (data.StatusMessage==data.ZipStatusMessageList[0] || data.StatusMessage==data.ZipStatusMessageList[4] || data.StatusMessage==data.ZipStatusMessageList[7]) { 
            if (data.StatusMessage==data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
            } else {
              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
              COSTCO.OrderSummary.placeOrder();
            }
          } else if (data.StatusMessage==data.ZipStatusMessageList[2]) {
            COSTCO.OrderSummary.placeOrder();
          } else if (data.StatusMessage==data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
          } else {
            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
              window.location.replace('http://'+$('#desktopHostName').val())
            })
          }
        }
      }
    },
    addressValidateSuccessOnSubmitShipping: function(data, params, form, chosenAddress) {
      $('#addressFormInlineButton').removeAttr('disabled');
      $('#changeDeliveryText1').hide();$('#changeDeliveryText2').hide();$('#changeDeliveryText3').hide();$('#changeDeliveryText4').hide();$('#locationZipError').hide();	
      var userDeliveryMethod = '';
      var isUserCurrentOrderItemsAvailable = $('#isUserCurrentOrderItemsAvailable').val();
      //Set address type
      if (COSTCO.util.isNdEnabled()) {
        userDeliveryMethod = $('form#CheckoutReviewForm input[name=orderShipmodeId]').val() == '10101' ? 'Local' : 'Nationwide';
        if (data.WarehouseChange && !data.ShowAddressTypePopup) {
          userDeliveryMethod = 'Nationwide';
        }
        if (data.WarehouseChange && data.IsInBDTruckZoneOnly) {
          userDeliveryMethod = 'Local';
        }
        if (data.WarehouseChange && data.IsStorePickupOnly) {
          userDeliveryMethod = 'Store-Pick-Up';
        }
        data.userSelectionDeliveryMethod = userDeliveryMethod;
      }
      if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && userDeliveryMethod == 'Nationwide') {
        COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
          window.location.replace('http://'+$('#desktopHostName').val())},"residentialNotServiced")
      } else if (data.BargeOrderZip == true) {
        $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
        $('#NewAddressSingleShippingForm').submit();  		
      } else if (((data != undefined && data.ExternalCarrierChange && userDeliveryMethod == 'Nationwide' ) || 
                  (data != undefined && data.WarehouseChange && userDeliveryMethod == 'Local' )) && isUserCurrentOrderItemsAvailable) {
        COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form, undefined, userDeliveryMethod);
      } else {
        if (data.StatusMessage==data.ZipStatusMessageList[4] && isUserCurrentOrderItemsAvailable) {
          COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
          COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
        } else {
          if (data.StatusMessage==data.ZipStatusMessageList[0]  || data.StatusMessage==data.ZipStatusMessageList[4] || 
              data.StatusMessage==data.ZipStatusMessageList[7]) { 
            if (data.StatusMessage==data.ZipStatusMessageList[7] && COSTCO.CAddress.isZipOrDeliveryMethodChange(data, userDeliveryMethod)) {
              COSTCO.zipCodeModal.launchModal(data, params, form, undefined, userDeliveryMethod);
            } else {
              COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
              COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
              $('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
              $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
              $('#NewAddressSingleShippingForm input[name="orderShipmodeId"]').val($('form#CheckoutReviewForm input[name=orderShipmodeId]').val()) ;
              $('#NewAddressSingleShippingForm').submit();
            }
          } else if (data.StatusMessage==data.ZipStatusMessageList[2]) {
            $('#NewAddressSingleShippingForm input[name="addressId"]').val(chosenAddress.id);
            $('#NewAddressSingleShippingForm').submit();
          } else if (data.StatusMessage==data.ZipStatusMessageList[5] && data.NewWarehouseAlert.length > 0) {
            COSTCO.zipCodeModal.launchModal(data, params[2] ? [params[2]] : params, form);
          } else {
            COSTCO.CAddressForm.addressNotServicedModal(chosenAddress, undefined, function(){
              window.location.replace('http://'+$('#desktopHostName').val())
            })
          }
        }
      }
    },
    addEditAddress: function(verifiedAddress, preventajaxhtml, addressOptions, message) {

      if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !COSTCO.CAddressForm.isFormCompleted('S') && verifiedAddress.addressType!='B'&& checkoutPage) {
        if (checkoutPage === 'shipping') {
          //COSTCO.CAddress.submitAddress(null, verifiedAddress.id, $('#formshipping'), verifiedAddress);
          $('#formshipping').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formshipping'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
        } else if (checkoutPage === 'review') {
          $('#formreview').find('[name=zipCodeFormDeliveryZipCode]').val(verifiedAddress.zip);
          COSTCO.zipCodeModal.submitZipCodeForValidation($('#formreview'), COSTCO.CAddress.addressValidateSuccess, COSTCO.CAddress.addressSetZipSuccess, verifiedAddress.id, undefined, verifiedAddress);
        }
      } else {
        let callAddressAdd = function(addressType) {
          CAddress.applyAddressToWhat(addressType)
          if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
            CAddress.addressTools.applyAddressToOrderItems = 'false';
          }
          var labels = CAddress.getHeaderLabels(addressType, 'add');
          var oldZipcode;
          var orderHasEddItems = $('#orderHasEddItems').val();
          if (!addressOptions.addressBookReinit && verifiedAddress.addressType === 'S' && undefined !== orderHasEddItems) {
            if (orderHasEddItems === 'true') {
              oldZipcode= $.cookie("invCheckPostalCode");
              if (typeof(sessionStorage) !== "undefined" && null !== oldZipcode) {
                sessionStorage.setItem('oldZipcode',oldZipcode);
              }
              $.cookie("invCheckPostalCode", verifiedAddress.zip.toUpperCase());
              $.cookie("invCheckStateCode", verifiedAddress.state);
              $.cookie("invCheckCity", verifiedAddress.city);
            }
            
          //update WAREHOUSEDELIVERY_WHS cookie
            if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof verifiedAddress.zip !== 'undefined') {
            	CAddress.updateWarehouseCookie(verifiedAddress.zip.toUpperCase());
			}

          }
          var options = {
            url: (verifiedAddress.id !== "" ? CAddress.urlAddUpdate(addressOptions) : CAddress.urlAdd(addressOptions)),
            method: "POST",
            dataType: 'json',
            data:   { 'authToken': COSTCO.Checkout.getAuthToken(),'oldZipcode': oldZipcode,formdata: encodeURIComponent(JSON.stringify(verifiedAddress))} ,
           
            replaceKey: {
              original: 'address-block',
              replace: labels.replaceKey
            },
            done: function (data, textStatus, jqXHR, options) {
              if (!data.errorMessage) {
                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
                  COSTCO.CreditCard.initComplete = false;	
                }
                COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
              } else {
                var parentNode = document.getElementById("costcoModalText");
                if (parentNode !== null) {
                  var newDiv = document.createElement("div");
                  //BD ALM-3463 fix repetitive error msg
                  if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val())) {
                    var errorDiv = document.getElementById("addressValidationError");
                    if(errorDiv !== null){
                      errorDiv.remove();
                    }
                      newDiv.id = 'addressValidationError';
                  }
                  newDiv.innerHTML = data.errorMessage;
                  newDiv.className = 'error'
                  parentNode.prepend(newDiv);
                }
              } 
            },
            ajax_update_post_done: function(data) {
              var application = data.error.application;
              if (application.length === 0) {
                COSTCO.util.resetAddressLoadState();
                COSTCO.CAddress.closeModal();
                $('body').trigger("costco.address.added", data.payload.data[1]);
              } else {
                $('body').trigger("costco.address.error", application);
              }
              CAddress.bindEvents();
              if(addressOptions.addressBookReinit) {
                COSTCO.CAddressBook.init();
              }
              if (typeof checkoutPage !== 'undefined' && checkoutPage) {
                apiAlreadyCalled = undefined;
                COSTCO.OrderItems.init();
                
                if (checkoutPage === 'review') {
                  COSTCO.CreditCard.initComplete = false;
                  COSTCO.CreditCard.init();
                  if (COSTCO.util.isBusinessDelivery()) {
                     COSTCO.Header.miniShopCartRefresh();
                  }
                } 
              }
            },
            always: function() {                
                COSTCO.preauthchargesmodal.init();
            },
          }
          if (preventajaxhtml) {
            options.ajax_replace_content = function() {};
          }
            COSTCO.Checkout.ajax_update_state(options);
        }

        let addressType = '';
        if (verifiedAddress.addressType === null) {
          addressType = (verifiedAddress.addressType2 !== null)? verifiedAddress.addressType2.trim(): '';
        } else {
          addressType = verifiedAddress.addressType.trim();
          let uniquePageSelector = '';
            if (typeof checkoutPage !== 'undefined' && checkoutPage) {
              if (checkoutPage === 'multi-shipping') {
                uniquePageSelector = '#single-page-checkout-multi-address';
              } else {
                uniquePageSelector = '#shipping';
              }
            } else {
               uniquePageSelector = '#shippingTab';
            }
            $(uniquePageSelector).find('input[id="addressEnteredForCheck"]').remove();
            $(uniquePageSelector).append('<input type="hidden" id="addressEnteredForCheck" value="'+verifiedAddress.line1+'"/>');
        }
        // Prevent code breaking if checkoutPage is undefined to fix STRY0158367-Use-
        // address-functionality-does-notrespond-from-the-address-validation-modal
        let checkoutPageName = (typeof checkoutPage === 'undefined') ? false : checkoutPage;
        
        if (addressType === 'S' && !addressOptions.addressBookReinit && (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) || (checkoutPageName != 'shipping' && checkoutPageName != 'review'))) {
          let submitZipCodeForValidation = function() {
            let submitParams = [addressType,addressOptions,preventajaxhtml];
            let form = $('#formshipping');
            let callBack = COSTCO.CAddress.addressValidateSuccessOnChooseAddress;
            if (checkoutPage == 'review') {
              form = $('#formreview');
            }
            form.find("input[name=zipCodeFormDeliveryZipCode]").val(verifiedAddress.zip);
            COSTCO.zipCodeModal.submitZipCodeForValidation(form,callBack, null, submitParams, null, verifiedAddress);
          }
          let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
          serviceToUpdateCookies(verifiedAddress.zip)
          .then(() => {
            if (COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined' &&
               (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message!='editAddressType') {
              submitZipCodeForValidation();
            } else {
              callAddressAdd(addressType);
            }
            
          },
          () => {
            //Allow the flow for CABD here, as we allow all codes if FSA is right, and delivery not segmented
            if (COSTCO.util.isBusinessDelivery() && COSTCO.util.isCABDStore() && typeof checkoutPage != 'undefined' &&
                (checkoutPage || checkoutPage === 'review' || checkoutPage === 'shipping') && message!='editAddressType') {
              submitZipCodeForValidation();
            }
          });
        } else {
          callAddressAdd(addressType);
        }
      }
    },
    getAddressType: function(addressId, type) {
      var string = '';
      for (var i = 0; i < COSTCO.util.addresses.length; i++) {
        if (COSTCO.util.addresses[i].id == addressId) {
          string = COSTCO.util.addresses[i].addressType.toUpperCase();
          break;
        }
      }
      if (string == '' && typeof(type) !== 'undefined') {
        string = type;
      }
      return string;
    },
    getAddressElement: function(addyId, prop, wholeObj) {
      for (var i = 0; i < COSTCO.util.addresses.length; i++) { // return specific obj
        if (wholeObj == true) {
          if (COSTCO.util.addresses[i].id == addyId) {
            return COSTCO.util.addresses[i]
          }
        } else if (COSTCO.util.addresses[i].id == addyId) { // return specific property
          return COSTCO.util.addresses[i][prop];
        }
      }
    },
    getSaveAddress: function(addressId, isChecked) {
      return addressId != '' ? CAddress.getAddressElement(addressId, 'addressType') == 'T' ? 'off' : 'on' : isChecked ? 'on' : 'off';
    },
    getDefaultAddress: function(addressId, isChecked) {
      if(isChecked) return 'on';
      return 'off';
    },
    isEmptyAddressType: function(type, addyObj) {
      for (obj in addyObj) {
        if (addyObj[obj].addressType === type) return false;
      }
      return true;
    },
    handleServerError: function(msg) { // put msg and show associated modal
      $(CAddress.addressTools.errorContainer).text(msg).show()
      if ($('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').length > 0) {
        $('.address-edit[addressid=' + CAddress.addressTools.cachedAddressId + ']').click()
      } else if (CAddress.addressTools.errorContainer == '#address-form .text-error') {
        $('#address-form-modal').costcoModal('showPartial full-page');
      }
      $('div').scrollTop($(CAddress.addressTools.errorContainer).offset().top - $('div').offset().top + $('div').scrollTop());
    },
    /**
     * If the user changes their address for grocery items, associate the
     * new address with all of the grocery items. Where 'this' is the select
     * DOM element. Called inline on MultiShippingItemAddress.jsp.
     * @return {void}
     */
    groceryItemAddress: function() {
      let selectedGroceryAddress = $(this).val()
      let $groceryAddresses = $('.grocery-address [name^=addressId_]');
      $groceryAddresses.val(selectedGroceryAddress);
    },
    //-End-Grocery changes
    getAddressJson: function(addressId, startAddress, type) {
      if (typeof(addressId) == 'undefined') {
        return COSTCO.util.addresses;
      }
      
      if (typeof(COSTCO.util) == 'undefined' || COSTCO.util.addresses.length == 0) {
        return [];
      }
      var returnArray = [];
      if (isNaN(addressId)) {
        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
          if (COSTCO.util.addresses[i].addressType.trim() == addressId) {
            returnArray.push(COSTCO.util.addresses[i]);
          }
        }
      } else {
        for (var i = 0; i < COSTCO.util.addresses.length; i++) {
          if (COSTCO.util.addresses[i].id == addressId) {
            returnArray.push(COSTCO.util.addresses[i]);
          }
        }
      }
      if (typeof(startAddress) !== 'undefined') {
        var foundIndex = 0;
        for (var i = 0; i < returnArray.length; i++) {
          if (returnArray[i].id == startAddress) {
            foundIndex = i;
          }
        }
        if (foundIndex > 0) {
          var arrayElement = returnArray.splice(foundIndex, 1)[0];
          returnArray.unshift(arrayElement);
        }
      }
      // Need to trim address types
      for (var i = 0; i < returnArray.length; i++) {
        returnArray[i].addressType = returnArray[i].addressType.trim();
      }
      return returnArray;
    },
    getStateProvJson: function(callback) {
      return countries;
	},
    /**
     * Function used to populate city and state in the responsive address form
     * Function is tied to the postal code element
     * 
     * Params
     * 		element -> jquery query that contain the postalCode input value
     * 		cityQuery -> jquery query that locate the input for city
     * 		stateQuery -> jquery query that locate the input for state
     * 
     */
    bingCityState: function(element, cityQuery, stateQuery) {
	  var query = $(element).val();

    var updateFormElements = function(data) {
      var province = null;
      var country = null;
      try {
          //Check out if country is Puerto Rico specific
          country = data.resourceSets[0].resources[0].address.countryRegionIso2;
          if (country != undefined && country === 'PR') {
            province = data.resourceSets[0].resources[0].address.countryRegionIso2;
            country = 'US';
          } else {
            province = data.resourceSets[0].resources[0].address.adminDistrict;
          }
        } catch (e) {
          province = "";
        }
        var city = null;
        try {
          city = data.resourceSets[0].resources[0].address.locality;
        } catch (e) {
          city = "";
        }
        
        if (COSTCO.CAddressForm !== undefined) {
           	COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
        	//COSTCO.CAddressForm.validate();
        }
    
      }
      COSTCO.util.callBing(query, updateFormElements);
	},
	/**
     * Function used to populate city and state in the responsive address form
     * Function is tied to the postal code element
     * 
     * Params
     * 		element -> jquery query that contain the postalCode input value
     * 		cityQuery -> jquery query that locate the input for city
     * 		stateQuery -> jquery query that locate the input for state
     * 
     */
    geocodeApiCityState: function(element, cityQuery, stateQuery, editAddrCity, editAddrState) {
    	
    	var query = $(element).val();

	    var updateFormElements = function(data) {
	    	var province = null;
	 	    var country = null;
	 	    var city = null;
	 	    try {
	 	    	city = data[0].city;
	 	        province = data[0].stateProvinceAbbreviation;
	 	        if (province == null) {
	 	        province = data[0].stateProvince;
	 	    	        }
	 	          country = data[0].country;
	 	   } catch (e) {
		    	  console.error('Error: '+ e.message);
		   }

		      if (COSTCO.CAddressForm !== undefined) {
		    	  COSTCO.CAddressForm.populateCityState(element.form, city, province, cityQuery, stateQuery);
		      }
    
	    };
	    
	    var updateFormElementsFromZipPostalCode = function(data) {
		    var provinceList = [];
		    var countryList = [];
		    var cityList = [];
		    try {
		    	    for (var i = 0; i < data.length; i++) {
		    	        if (data[i].city != undefined && !cityList.find(city => city === data[i].city)) {
		    	            cityList.push(data[i].city);
		    	        }

		    	        var existingProv = provinceList.find(prov => prov.code === data[i].stateProvinceAbbreviation);
		    	        if (data[i].stateProvinceAbbreviation != undefined && !existingProv) {
		    	            var prov = new Object();
		    	            prov.code = data[i].stateProvinceAbbreviation;
		    	            prov.displayName = data[i].stateProvince != null ? data[i].stateProvince : data[i].stateProvinceAbbreviation;
		    	            provinceList.push(prov);
		    	        }

		    	        if (data[i].country != undefined && !countryList.find(country => country === data[i].country)) {
		    	            countryList.push(data[i].country);
		    	        }
		    	    }
		    	
		    	
		      } catch (e) {
		    	  console.error('Error: '+ e.message);
		      }
	        
		      if (COSTCO.CAddressForm !== undefined) {
		    	  var form = undefined;
		    	  if($(element).form) {
		    		  form = $(element).form;
		    	  } else if($(element).prevObject) {
		    		  form = $(element).prevObject
		    	  } else if($(element).closest('form')) {
		    		  form = $(element).closest('form');
		    	  }
		    	  if(form != undefined){
		    		  COSTCO.CAddressForm.populateCityStateForZipPostalCode(form, cityList, provinceList, cityQuery, stateQuery, editAddrCity, editAddrState);
		    		  // COSTCO.CAddressForm.validate();
		    	}
		      }
	    
		    }
	    
	    var geocodeCallback = costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true" ?
	    		updateFormElementsFromZipPostalCode : updateFormElements;
	    
	    COSTCO.util.callGeocodeAPI(query, geocodeCallback);
	},

   
    bindEvents: function() {
      if (typeof checkoutPage !== "undefined" && checkoutPage === 'multi-shipping') {
        $('.addressid-selection').unbind('change').change(function() {
          var selectedOption = $(this).find(':selected');
          var name = selectedOption.attr('name');
          if (typeof(name) !== 'undefined' && name === 'add-new-address-option') {
        	  COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
          }
        });
        if ($('#addressId_1 option').length == 1) {
          $('.addressid-selection').unbind('click').click(function() {
            var selectedOption = $(this).find(':selected');
            var name = selectedOption.attr('name');
            if (typeof(name) !== 'undefined' && name === 'add-new-address-option') {
            	COSTCO.CAddressForm.createNewAddress('S', selectedOption.attr('orderitem-id'), true);
            }
          });
        }
      }
      COSTCO.CAddressForm.initiatePopovers();
    },
    /**
    * Changes the cookie and appends/removes EC as per condition
    * 
    */
    isZipOrDeliveryMethodChange: function(data, userSelection){
      var isChanged = false;
      currentCookie = $.cookie('WC_BD_WHS');
      if (COSTCO.util.isNdEnabled() && data && userSelection) {
        if ((userSelection == "Nationwide" || !data.ShowAddressTypePopup)&& currentCookie.search("-ND") == -1) {
          isChanged = true;
        } else if (userSelection == "Local" && currentCookie.search("-ND") != -1 && data.ShowAddressTypePopup) {
          isChanged = true;
        }
      }
      if (data && (data.CurrentDeliveryZip != data.SetDeliveryZip)) {
        isChanged = true;
      }
      return isChanged;
   },
   /**
    * The method sets all the required field so as to save the user selected address type to DB
    * and calls function to show the Address Type popup
  */
  addUserSelectionFromDelivery: function(obj){
	  
	  let addressJson = COSTCO.CAddress.getAddressJson(obj)[0];
      var addresstype = addressJson.userAddressType;
      if(document.querySelector('input[name="nd-radio-group-input"]:checked')!=null){
			addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
	  }
      COSTCO.CAddressVerification.entered = addressJson;
	  COSTCO.CAddressVerification.entered.addressType="S";
	  COSTCO.CAddressVerification.entered.saveAddress="on";
	  COSTCO.CAddressVerification.entered.setDefault="on";
	  COSTCO.CAddressVerification.entered.addressType2="S";
      COSTCO.CAddressVerification.entered.userAddressType = addresstype;
	  COSTCO.CAddressVerification.entered.userAddrTypeUpdate="Y";
	  COSTCO.CAddressVerification.viewAddressTypeModal(undefined, {},'editAddressType');
      
  },
//update WAREHOUSEDELIVERY_WHS cookie
  updateWarehouseCookie: function(zipcode){

	  var parsedCookie = JSON.parse($.cookie('WAREHOUSEDELIVERY_WHS'));
	  var responseJson;
	  var distCenterServiceUrl = $('#distributionCentersUrl').val()+'?destinationPostalCode='+zipcode.toUpperCase();
	  var headers = {
		  'costco.env': $('#distributionCentersEnv').val(),
	      'costco.service': 'restInventory',
	      'client-identifier': $('#distributionCentersClientId').val(),
	  }

		try {
			$.ajax({
	    		url: distCenterServiceUrl,
	            type: 'GET',
	            headers: headers,
	            dataType: 'json',
	            async:false,
	            success: function (data) {
	            	responseJson = data;
	            	parsedCookie.distributionCenters = responseJson.distributionCenters;
	            	parsedCookie.groceryCenters = responseJson.groceryCenters;
	            	$.cookie('WAREHOUSEDELIVERY_WHS', JSON.stringify(parsedCookie));
	            },
	            error: function (data) {
	            	responseJson = data;
	            	console.log("Error in updateWarehouseCookie: " + JSON.stringify(responseJson));
	            }
	        });
		} catch (e) {
  		console.error("Error in updateWarehouseCookie: " + e);
  	}

  }
}
  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  }
  window.COSTCO.CAddress = CAddress;
  return CAddress;
});



// WEBPACK FOOTER //
// ./js/address/address.js